import { render, staticRenderFns } from "./AddNewParamaCourses.vue?vue&type=template&id=3587bcb6"
import script from "./AddNewParamaCourses.vue?vue&type=script&lang=js"
export * from "./AddNewParamaCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports